import React from 'react'
import { useTranslation } from "react-i18next";
import {GetAlertsComponent,translateType} from "./utils"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
//OPERAÇÕES - Soma

export function SumBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("Adição")}
                        {(node.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null} 
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
            :
                <div style={{display:"flex"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("Adição")}
                    </div>
                </div>
            }
        </div>
    )
}

export function SumConfiguration(props){
    const { t } = useTranslation();
    let {handleConfigurationClose} = props
    let {node} = props
    let {read_only} = props

    return(
        <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column"}}>
            <div style={{display: "flex"}}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{fontSize: "14px", display:"flex", margin:"auto 5px"}}/>
                </Tooltip>
            </div>
            <div className={["internalCardContainer", "normalText", "normalMediumSize"].join("  ")} style={{display:"flex", flexDirection: "column"}}>
                {t("Não há configurações disponíveis para esse nó.")}
            </div>
            <div style={{display:"flex", margin: "auto auto 5px auto"}}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{width:"120px"}}
                    onClick={handleConfigurationClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
            </div>
        </div>
    )
}

export class SumBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        let put_error = false
        let alerts = []
        //Validate if node has at least one children
        if((node.node.children || []).length < 2){
            put_error = true
            alerts.push("Este nó precisa ter pelo menos dois filhos")
        }
        //Validate if all childrens of the node are Numbers
        else{
            var allowed_data_types = []
            let is_first_valid = true
            let firstChildrenType = node.node.children[0].instance.getType(node.node.children[0])

            if (firstChildrenType === "number") allowed_data_types = ["number"]
            else if (firstChildrenType === "timedelta") allowed_data_types = ["timedelta", "time", "datetime"]
            else if (["time", "datetime"].includes(firstChildrenType)) allowed_data_types = ["timedelta"]
            else {
                is_first_valid=false
                put_error = true
                alerts.push("O primeiro filho deste nó deve possuir um retorno Numérico, Período de Tempo, Horário ou Data e Horário. Atualmente é " + translateType(firstChildrenType))
            }
            if (is_first_valid){
                var child
                for (child of node.node.children.slice(1)){
                    let child_data_type = child.instance.getType(child)
                    if (!allowed_data_types.includes(child_data_type)){
                        put_error = true
                        alerts.push("Não é permitido somar " + translateType(firstChildrenType) + " com " + translateType(child_data_type))
                        break
                    }
                    if (["time", "datetime"].includes(child_data_type)) allowed_data_types = ["timedelta"]
                }
            }
        }
        //Validate if parent is valid
        if (node.parentNode != null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválida")
            }
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        if ((node.children || []).length ===0) return "void"

        var child
        for (child of node.children){
            let child_data_type = child.instance.getType(child)
            if (child_data_type === "number") return "number"
            else if (child_data_type === "time") return "time"
            else if (child_data_type === "datetime") return "datetime"
        }
        return "timedelta"
    }
}